import * as React from "react";
import { useTranslation } from "react-i18next";
import { connect, ConnectedProps } from "react-redux";

import { subpageContext } from "components/layout/ApplicationLayout";
import AddEntitlementWrapper from "components/licenses/entitlements/add-entitlement/AddEntitlementWrapper";
import { Container, EmsConfiguration, LicenseData } from "domain/licenses";
import { ProductRateList } from "services/licenses/LicenseService";
import { StoreState } from "store";
import buttonsStyle from "styles/buttons.scss";

const connector = connect((state: StoreState) => ({
    user: state.userReducer.user,
}));

interface Props {
    emsConfiguration: EmsConfiguration;
    availableLicenses: LicenseData[];
    slContainers: Container[];
    onUpdate: () => void;
    tokenRates?: ProductRateList[];
}

const AddEntitlementView = (props: Props & ConnectedProps<typeof connector>): JSX.Element => {
    const { t } = useTranslation();
    const context = React.useContext(subpageContext);
    function hideEntitlementForm() {
        context?.setSubpage({
            content: undefined,
        });
    }
    const createEntitlements = () => {
        context?.setSubpage({
            content: (
                <AddEntitlementWrapper
                    emsConfiguration={props.emsConfiguration}
                    availableLicenses={props.availableLicenses}
                    onUpdate={props.onUpdate}
                    allContainers={props.slContainers}
                    modalVisibility={true}
                    setModalVisibility={hideEntitlementForm}
                    tokenRates={props.tokenRates}
                />
            ),
            isModal: false,
        });
    };

    return (
        <button
            className={buttonsStyle.primaryButtonWithoutIcon}
            onClick={() => {
                createEntitlements();
            }}
        >
            {t("AddEntitlementsView.addEntitlementButton")}
        </button>
    );
};
export default connector(AddEntitlementView);
